import { SEND_SMS_REQUEST } from "../constant";

export const sendSMS = (body) => ({
  type: SEND_SMS_REQUEST,
  endpoint: "/admin/sms",
  body,
});
